import React from "react";
import { Form, Input, Button, Typography, Radio, notification, DatePicker } from "antd";
import useRegistrationForm from "../../hooks/useRegisterationForm";

const { Title, Text } = Typography;

const RegistrationForm = ({ isWebinar = false }) => {
  const { handleSubmit, contextHolder } = useRegistrationForm();
  const [form] = Form.useForm();

  return (
    <div className="px-5 py-8 bg-white md:w-[577px] text-gray-900 rounded-xl md:rounded-3xl flex flex-col gap-4 shadow-2xl"
    >
      {contextHolder}
      {isWebinar ? <p className="text-2xl text-center text-slate-800" >Join the Webinar and Level Up!</p> :
        <Title level={3} className="!mb-0">{"Sign Up"}</Title>
      }
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          name: "",
          email: "",
          phoneNumber: "",
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="Enter your name" size="large" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Email is required" },
            { type: "email", message: "Invalid email address" },
          ]}
        >
          <Input placeholder="Enter your email" size="large" />
        </Form.Item>
        <Form.Item
          label="Phone Number"
          name="phoneNumber"
          rules={[
            { required: true, message: "Phone number is required" },
            {
              pattern: /^\+?[1-9]\d{1,14}$/,
              message: "Enter a valid phone number (e.g., +1234567890)",
            },
          ]}
        >
          <Input placeholder="Enter your phone number with country code" size="large" />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[
            { required: true, message: "Password is required" },
            {
              pattern: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z]).{8,}$/,
              message: "Password must be at least 8 characters long, with at least 1 number, 1 special character, 1 uppercase letter, and 1 lowercase letter.",
            },
          ]}
        >
          <Input.Password placeholder="Enter your password" size="large" />
        </Form.Item>
        {/* <Form.Item
          label="Date of Birth"
          name="dob"
          rules={[
            { required: true, message: "Date of Birth is required" },
          ]}
        >
          <DatePicker placeholder="Select your date of birth" size="large"
            className="w-full"
          />
        </Form.Item> */}
        {/* <Form.Item
          label="Experience"
          name="experience"
          rules={[{ required: true, message: "Please select an experience option" }]}
        >
          <Radio.Group>
            <Radio value="Working professional">Working professional</Radio>
            <Radio value="College Student - Final year">College Student - Final year</Radio>
            <Radio value="College Student - 1st year to pre-final year">
              College Student - 1st year to pre-final year
            </Radio>
            <Radio value="Others">Others</Radio>
          </Radio.Group>
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" size="large" className="w-full !bg-blue-900 hover:!bg-blue-700">
            {isWebinar ? "Join Now" : "Sign Up"}
          </Button>
        </Form.Item>

        <Text className="text-sm text-gray-600 mt-3">
          I authorize Pronttera Labs to contact me with course updates & offers via
          Email/SMS/Whatsapp/Call. I have read and agree to Privacy Policy & Terms of use.
        </Text>
      </Form>
    </div>
  );
};

export default RegistrationForm;
